/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Link, Stack, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import ValidationError from "../../../components/validation-error-label";
import FullScreenLoader from "../../../components/full-screen-loader";
import { isEmpty, isValidEmail } from "../../../utils/validator";
import { POST } from "../../../config/https";
import APIS from "../../../config/api";
import Color from "../../../theme/color";
import { useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail]: any = useState("");
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [isValidation, setIsValidation] = useState(false);
  const [loader, setLoader] = useState(false);
  const [signStatus, setSignStatus] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (isValidation) {
      validator();
    }
  }, [email]);

  const handleClick = async () => {
    setIsValidation(true);
    if (!validator()) return;
    setLoader(true);
    let params = {
      email: email,
    };
    await POST(APIS.FORGOT_PASSWORD, params)
      .then((res: any) => {
        if (res?.isSuccess) {
          setSignStatus(true);
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const validator = () => {
    const errors: Record<string, string> = {};
    if (isEmpty(email)) {
      errors.email = "Please enter a email";
    }

    if (!isEmpty(email) && !isValidEmail(email)) {
      errors.email = "Please enter a valid email";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const toggleForm = () => {
    navigate("/login");
  };

  const handleKeyPress = (event: any) => {
    if (event.key === "Enter") {
      handleClick();
    }
  };

  return (
    <>
      <Stack spacing={2}>
        <TextField
          value={email}
          label="Email"
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          onKeyPress={handleKeyPress}
        />
        <ValidationError formErrors={formErrors.email} />
      </Stack>
      <Typography variant="body2" sx={{ mb: 2, mt: 2 }}>
        <Link
          style={{
            textDecoration: "none",
            fontSize: "15px",
          }}
          onClick={toggleForm}
          variant="subtitle2"
          underline="hover"
          component="button"
        >
          Sign In
        </Link>
      </Typography>
      {signStatus ? (
        <Typography
          sx={{ paddingBottom: "5px" }}
          style={{
            marginTop: 1,
            marginBottom: 1,
            color: "Green",
            width: "100%",
            fontSize: "12px",
            fontWeight: 400,
          }}
        >
          Please check your email for the reset password link that has been
          sent.
        </Typography>
      ) : (
        ""
      )}
      <LoadingButton
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        onClick={handleClick}
        style={{ backgroundColor: Color.primary, fontSize: "17px" }}
      >
        Submit
      </LoadingButton>
      <FullScreenLoader open={loader} />
    </>
  );
}
